import MapDraw from 'map/MapDraw';
import { RouteOption } from 'map/types/route';
import { MachineCoordinate } from 'types/common/machine.type';
import { Tenant } from 'types/common/tenant.type';
import { findObject } from './object';

// 경로 탐색
export const getRoute = async (routeOption: RouteOption) => {
  const naviResponse = await MapDraw.mapData.getRoute(routeOption);
  return naviResponse;
};

// 경로 탐색
export const findRoute = async (machinePosition: MachineCoordinate, tenant: Tenant | null) => {
  if (!tenant) {
    return;
  }

  console.log('Origin coordinates', machinePosition);
  console.log('Destination tenantId', tenant.id);

  // object 있을 경우 -> objectId 로 길찾기
  if (tenant.content.objectId) {
    // object 정보 탐색
    const findMapObject = findObject({ id: tenant.content.objectId });

    if (!findMapObject) {
      console.warn('Object not found');
      return;
    }

    const routeOption: RouteOption = {
      origin: {
        position: { x: Number(machinePosition.x), y: Number(machinePosition.y) },
        floorId: MapDraw.machine.floor.id,
      },

      // opening 을 타려면 objectId 를 사용해야 함
      destination: {
        // position: { x: Math.abs(destinationPosition.x), y: Math.abs(destinationPosition.y) },
        floorId: tenant.content.floorId,
        objectId: tenant.content.objectId,
      },
      type: ['recommendation', 'elevator', 'escalator', 'stairs'],
      waypoints: [],
    };

    const naviResponse = await getRoute(routeOption);
    console.log('Navigate by objectId', findMapObject.id);
    return naviResponse;
  }

  // object 없을 경우 -> poiId 로 길찾기
  const routeOption: RouteOption = {
    origin: {
      position: { x: Number(machinePosition.x), y: Number(machinePosition.y) },
      floorId: MapDraw.machine.floor.id,
    },
    destination: {
      poiId: tenant.content.poiId,
      floorId: tenant.content.floorId,
    },
    type: ['recommendation', 'elevator', 'escalator', 'stairs'],
    waypoints: [],
  };

  const naviResponse = await getRoute(routeOption);
  console.log('Navigate by poiId', tenant.content.poiId);

  return naviResponse;
};
